import { useTheme } from '@rneui/themed'
import React from 'react'
import { ActivityIndicator, ColorValue, View } from 'react-native'

interface Props {
  size?: 'small' | 'large' | number
  color?: ColorValue
}

export default function Spinner(props: Props) {
  const { theme } = useTheme()
  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
      <ActivityIndicator
        size={props.size ?? 'large'}
        color={props.color ?? theme.colors?.primary}
      />
    </View>
  )
}
